import {useTestRoom} from "../../../../../hooks/useTestRoom";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {Button, Card, Divider, Grid, Stack, Typography} from "@mui/joy";
import {Question, QuestionGroup, QuestionType, RawQuestion} from "../../../../../models/question";
import IeltsMatchingQuestionComponent from "../question/IeltsMatchingQuestionComponent";
import IeltsMultipleChoiceQuestionComponent from "../question/IeltsMultipleChoiceQuestionComponent";
import IeltsOpenAnswerQuestionComponent from "../question/IeltsOpenAnswerQuestionComponent";
import IeltsTrueFalseQuestionComponent from "../question/IeltsTrueFalseQuestionComponent";
import IeltsWritingTaskQuestionComponent from "../question/IeltsWritingTaskQuestionComponent";
import IeltsSpeakingQuestionComponent from "../question/IeltsSpeakingQuestionComponent";
import {useTranslation} from "react-i18next";
import {useFeedback} from "../../../../../hooks/useFeedback";
import {Mic} from "lucide-react";

type IeltsSpeakingQuestionComponentProps = {
    audioContent: {
        [v in "questions" | "instructions"]: { [k: number]: string[] }
    }
}

const IELTS_SPEAKING_PART_MAP = {
    1: "ieltsSpeakingPartOneLabel",
    2: "ieltsSpeakingPartTwoLabel",
    3: "ieltsSpeakingPartThreeLabel",
}

const IeltsSpeakingTestRoomComponent = (props: IeltsSpeakingQuestionComponentProps) => {
    const testRoom = useTestRoom()
    const {t} = useTranslation()
    const [questions, setQuestions] = useState<Question[]>([])

    useEffect(() => {
        setQuestions(prevState => {
            const questionsSlice = prevState.slice()
            questionsSlice.push(...testRoom.questions.filter(value => value.subSectionNumber === testRoom.currentSubsectionNumber))
            return questionsSlice
        })
    }, [testRoom.currentSubsectionNumber, testRoom.questions])


    return <Stack gap={4} sx={{
        overflowY: {xs: "auto", md: "hidden"},
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
    }}>

        <Typography level={"h3"}>
            {t("ieltsSectionTerminology", {sectionNumber: testRoom.currentSubsectionNumber})}: {t(IELTS_SPEAKING_PART_MAP[testRoom.currentSubsectionNumber])}
        </Typography>

        <IeltsSpeakingQuestionComponent questions={questions}
                                        audioContent={{
                                            questions: props.audioContent.questions[testRoom.currentSubsectionNumber],
                                            instructions: props.audioContent.instructions[testRoom.currentSubsectionNumber],
                                        }}/>

        {/*{!micPermissionGranted &&*/}
        {/*    <Stack width={"100%"} height={"100%"} position={"absolute"} justifyContent={"center"} sx={{backgroundColor: "rgba(0,0,0,0.4)"}}>*/}

        {/*        <Card variant={"plain"} sx={{gap:1.5, alignItems:"center", margin:2}} color={"secondary"}>*/}
        {/*            <Mic style={{fontSize: 60, color: "inherit"}}/>*/}
        {/*            <Typography>*/}
        {/*                {t("allowMicPrompt")}*/}
        {/*            </Typography>*/}
        {/*            <Button color={"secondary"} onClick={initializeMediaPermissions}>*/}
        {/*                {t("allowMicActionButtonLabel")}*/}
        {/*            </Button>*/}
        {/*        </Card>*/}

        {/*    </Stack>}*/}

    </Stack>
}

export default IeltsSpeakingTestRoomComponent